function normalizeProductCharacteristics(product, offer) {
  let res = {};
}

export { normalizeProductCharacteristics };
